<template>
  <PackageTradeItemParentRow
    v-if="tradeItem.has_children"
    :trade-item="tradeItem"
    :package="package"
    :show-edit-buttons="showEditButtons"
    :scrollable-container="scrollableContainer"
    :depth="depth"
    @delete="$emit('delete', $event)"
  />

  <PackageTradeItemChildRow
    v-else-if="packageTradeItem"
    :package-trade-item="packageTradeItem"
    :show-edit-buttons="showEditButtons"
    :package="package"
    :scrollable-container="scrollableContainer"
    :depth="depth"
    @delete="$emit('delete', packageTradeItem)"
  />
</template>

<script setup lang="ts">
import Package from '@/models/Package';
import PackageTradeItem from '@/models/PackageTradeItem';
import TradeItem from '@/models/TradeItem';
import { usePackageTradeItemsStore } from '@/store/packageTradeItems';
import { computed } from 'vue';
import PackageTradeItemChildRow from './PackageTradeItemChildRow.vue';
import PackageTradeItemParentRow from './PackageTradeItemParentRow.vue';

const props = withDefaults(
  defineProps<{
    tradeItem: TradeItem;
    showEditButtons: boolean;
    package: Package;
    scrollableContainer: HTMLElement;
    depth?: number;
  }>(),
  {
    depth: 0,
  },
);

defineEmits<{
  (e: 'delete', packageTradeItem: PackageTradeItem): void;
}>();

const packageTradeItemsStore = usePackageTradeItemsStore();

const packageTradeItem = computed(() => {
  return packageTradeItemsStore.models
    .where('package_id', props.package.id)
    .where('trade_item_id', props.tradeItem.id)
    .with('wbs_code')
    .with('trade_item')
    .first();
});
</script>

<style scoped></style>
